import { Pagination, PaginationV2 } from "@/domain/entities/Pagination";
import {
  ProductConfigurationRule,
  ProductConfigurationRuleList,
  ProductData,
  ProductEntities,
  ProductSender
} from "@/domain/entities/Product";
import { AxiosResponse } from "axios";
import {
  ResponsePayload,
  ResponsePayloadV2
} from "@/domain/entities/ResponsePayload";

export class ProductDataMapper {
  public convertProductDataFromApi(res: AxiosResponse<any>): ProductEntities {
    const { data } = res;

    const vendors: ProductData[] = [];
    if (data.data.length === 0) {
      return new ProductEntities(
        new Pagination(data.meta.page, data.meta.limit),
        []
      );
    } else {
      data.data.map((item: any) => {
        vendors.push(
          new ProductData({
            id: item.product_type_id,
            name: item.product_type_code,
            eCargoProduct: item.product_type_cargo_product_type_code,
            description: item.product_type_description,
            status: item.product_type_status,
            createdBy: item.created_by,
            updatedBy: item.updated_by,
            createdAt: item.created_at,
            updateAt: item.updated_at
          })
        );
      });
    }
    return new ProductEntities(
      new Pagination(data.meta.page, data.meta.limit),
      vendors
    );
  }

  public convertDetailProductDataFromApi(
    result: AxiosResponse<any>
  ): ProductData {
    const { data } = result;

    return new ProductData({
      id: data.data.product_type_id,
      name: data.data.product_type_code,
      eCargoProduct: data.data.product_cargo_product_type_code,
      description: data.data.product_type_description,
      status: data.data.product_type_status,
      createdBy: data.data.created_by,
      updatedBy: data.data.updated_by,
      createdAt: data.data.created_at,
      updateAt: data.data.updated_at
    });
  }

  public convertChangeDataFromApi(result: AxiosResponse<any>): ResponsePayload {
    const { data } = result;
    return new ResponsePayload({
      success: data.success,
      message: data.message
    });
  }

  public convertDataProductConfigurtionRule(
    result: AxiosResponse
  ): ProductConfigurationRuleList {
    const {
      data: { data }
    } = result;
    return new ProductConfigurationRuleList({
      data: data.map((item: any) => {
        return new ProductConfigurationRule({
          metaRule: JSON.parse(item.cr_excluded_booked_for),
          product: item.cr_product_type,
          ruleKey: item.cr_rules,
          parameter: parseFloat(item.cr_rules.match(/[\d.]+/)?.[0] ?? "") || 0.31,
          isCampaign: item.cr_flag === "campaign",
          lowVolume: item.low_volume,
          prefixShipment: item.prefix_shipment
        });
      })
    });
  }

  public convertProductSenderListDataFromApi(
    result: AxiosResponse<any>
  ): ResponsePayloadV2 {
    const { data } = result;

    return new ResponsePayloadV2({
      pagination: new PaginationV2({
        page: data.meta.page,
        limit: data.meta.limit
      }),
      data: data.data.length
        ? data.data.map(
            (item: any) =>
              new ProductSender({
                productTypeId: item.product_type_id,
                productTypeCode: item.product_type_code,
                productTypeDescription: item.product_type_description,
                productTypeStatus: item.product_type_status,
                productTypePriority: item.product_type_priority,
                productTypeCargoProductTypeCode:
                  item.product_type_cargo_product_type_code,
                createdBy: item.created_by,
                updatedBy: item.updated_by,
                createdAt: item.created_at,
                updatedAt: item.updated_at
              })
          )
        : []
    });
  }

  public convertVolumetricDivisorFromApi(
    result: AxiosResponse<any>
  ): Record<string, number> {
    const body = result?.data;
    if (
      !body ||
      body.code !== 200 ||
      body.data === null ||
      body.data === undefined ||
      typeof body.data !== "object" ||
      Array.isArray(body.data)
    ) {
      return {};
    }
    const out: Record<string, number> = {};
    for (const [key, val] of Object.entries(body.data)) {
      if (typeof val === "number" && !Number.isNaN(val)) {
        out[key] = val;
      }
    }
    return out;
  }

  public convertInternationalVendorConfigResolveFromApi(
    result: AxiosResponse<any>
  ): boolean {
    const body = result?.data;
    if (!body || body.code !== 200 || !body.data || typeof body.data !== "object") {
      return false;
    }
    return body.data.multiple_pieces === true;
  }
}
